export default __webpack_public_path__ + "static/media/215.6121af11.gif";